import { ScaleElement } from '@scale/base-element';

class ScaleFlipCard extends ScaleElement {
  setup() {
    const trigger = this.ref('trigger');
    if (trigger) {
      this.on('click', () => this.#toggle(), { target: trigger });
    }
  }

  #toggle() {
    this.#setFlipped(!this.classList.contains('is-flipped'));
  }

  #setFlipped(flipped) {
    this.classList.toggle('is-flipped', flipped);
    this.ref('trigger')?.setAttribute('aria-pressed', String(flipped));
  }

  onBlockSelect(e) {
    const block = this.querySelector(`#shopify-block-${e.detail.blockId}`);
    if (!block) return;
    this.#setFlipped(block.closest('.flip-card__back') !== null);
  }

  onBlockDeselect() {
    this.#setFlipped(false);
  }
}

if (!customElements.get('scale-flip-card')) {
  customElements.define('scale-flip-card', ScaleFlipCard);
}
